import React, {Component} from 'react';
import ExtractService from "../../../Services/ExtractService";
import {ContentImgStyled, H3Styled, ImgStyled, MainContentStyled, P1Styled, PrintButtonStyled} from "./styled";
import {Typography} from "@material-ui/core";
import JsPDF from "jspdf";
import PrintIcon from '@material-ui/icons/Print';
import DateUtil from "../../../Utils/DateUtil";
import {ValidationReportContext} from "../../../Contexts/ValidationReportContext";

class PdfValidationReportPage extends Component {
    static contextType = ValidationReportContext;
    static ROUTE = '/validation-report/pdf';

    constructor(props) {
        super(props);

        this.state = {
            data: null
        };

        this.extractService = new ExtractService();
    }

    componentDidMount() {
        this.load();
    }

    load = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const myParam = urlParams.get('value');

        console.log(JSON.parse(myParam));
        this.setState({
            data: JSON.parse(myParam),
        });
    }

    makePdf = () => {
        document.title = `comprovante_meu_app.pdf`;
        window.print();
    }

    render() {
        if (this.state.data == null) {
            return <></>;
        }

        const data = this.state.data;

        return (
            <MainContentStyled>
                <ContentImgStyled>
                    <ImgStyled src="https://homolog.meuappdefidelidade.com.br/static/media/logo_login.8bc432d2.png"/>
                </ContentImgStyled>
                <H3Styled>Meu App de Fidelidade</H3Styled>
                <br/><br/>
                <P1Styled>Comprovante</P1Styled>
                <br/>
                <p>Tipo: {data?.type}</p>
                <p>Cadastro em: {data?.created_at}</p>
                <p>Estabelecimento: {data?.fantasy_name}</p>
                <p>Operador: {data?.validated_by}</p>
                <p>Divergência: {data?.difff}</p>
                <p>Dados da divergência:</p>
                <p>Cadastrado: {data?.original_amount}</p>
                <p>Recebido: {data?.received_amount}</p>

                <PrintButtonStyled onClick={this.makePdf}>
                    <PrintIcon/>
                </PrintButtonStyled>
            </MainContentStyled>
        );
    }
}

export default PdfValidationReportPage;